export const FROM_BLOCK = 38_110_000; // block from Jan-12-2023
export const FROM_BLOCK_EPISODE_2 = 43_000_000; // block from Nov-30-2023
